/* unplugin-vue-components disabled */import script from "./DishDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DishDetail.vue?vue&type=script&setup=true&lang=js"

import "./DishDetail.vue?vue&type=style&index=0&id=36b91f57&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b91f57"]])

export default __exports__